export default "__VITE_ASSET__6c8add23__"